import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SubscriptionObject } from 'app/shared/models/standard.models';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { DAWASearch } from 'app/shared/utilities/dawa';

@Component({
  selector: 'jublo-vat',
  templateUrl: './vat.component.html'
})
export class VatComponent implements OnInit, OnDestroy {
  @Input() vat: string | null = null;
  @Input('options') o:any;
  @Output() vatChange = new EventEmitter<string>();
  @Output() company = new EventEmitter();

  companyLanguage: string = 'da-DK';
  dawa = new DAWASearch(this.http);
  options = new VatOptions();
  searching:boolean = false;
  subscriptions: SubscriptionObject = {};
  result:any;

  constructor(private http: HttpClient, private shared: SharedDataService) { }

  ngOnInit(): void {
    this.subscriptions['language'] = this.shared.companyInformation().subscribe({
      next:(data) => this.companyLanguage = data.companyLanguage
    })
  }

  ngOnDestroy(): void {
    for(let x of Object.keys(this.subscriptions)) this.subscriptions[x].unsubscribe();
  }

  search(search: KeyboardEvent){
    if(this.companyLanguage != 'da-DK'){
      this.vatChange.emit((search.target! as HTMLInputElement).value!);
    }
    else if( (search.key == 'Enter' || search.code == 'Enter') && !!this.result) {
      this.pickResult()
    }
    else {
      this.dawa.vat((search.target! as HTMLInputElement).value, this.companyLanguage).subscribe({
        next:(data) => {
          this.searching = true;
          this.result = data;
        }
      });
    }
  }

  doneSearching(){ setTimeout(()=> { this.searching = false; } , 200) }

  pickResult(){
    this.vatChange.emit(this.result.vat.toString());
    this.searching = false;
    this.company.emit(this.result);
    setTimeout(()=> this.result = null, 200);
  }
}

class VatOptions {
  classes: string = 'form-control borderless';
  defaultRelative:boolean = true;
  zIndex:number = 20;
  scrollParent: string = '.modal-body';
}
